import React from 'react';
import SvgIcon from './svg-icon.jsx';

export default function SendMessageIcon({
  className = '',
  width = 16,
  height = 18,
  title,
  ...props
}) {
  return (
    <SvgIcon
      name="send"
      viewBox="0 0 16 18"
      width={width}
      height={height}
      className={['send-message-icon', className].filter(Boolean).join(' ')}
      title={title}
      {...props}
    />
  );
}
